var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24.211 20.036"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(-3158.607 -871.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M3167.1,887.99c5.168-3.119,10.948-8.389,15.721-12.208-.751-.789-1.515-1.578-2.266-2.367a.564.564,0,0,0-.929-.089c-3.87,3.016-7.587,7.535-11.877,9.929a1.082,1.082,0,0,1-.725.19,1.015,1.015,0,0,1-.535-.42c-.649-.8-1.056-1.782-1.706-2.584a1.589,1.589,0,0,0-.814-.662c-.433-.1-.828.255-1.464.764-.547.433-1.158.777-1.706,1.209,1.591,1.528,3.539,4.43,5.13,5.958a1.219,1.219,0,0,0,.624.394,1.111,1.111,0,0,0,.547-.114",
    fill: "#79de75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M3168.625,891.834a10.018,10.018,0,1,1,7.09-17.1.315.315,0,1,1-.445.446,9.388,9.388,0,1,0,2.749,6.632.3.3,0,0,1,.306-.3.309.309,0,0,1,.3.3,10.009,10.009,0,0,1-10,10.018",
    fill: "#4c4c4c"
  })))));
};
export default __webpack_public_path__ + "static/media/selected_language.d68124ce.svg";
export { SvgComponent as ReactComponent };